import { IconProps } from "./types";

export default function IcoTravel({
	color = "#707070",
	width = "26",
	height = "21"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 26 21"
			fill="none"
		>
			<g clipPath="url(#clip0_636_3443)">
				<path
					d="M2.6875 4.5625V8H6.4375V4.25H3C2.82812 4.25 2.6875 4.39062 2.6875 4.5625ZM21.5156 8L18.3555 4.25H15.1875V8H21.5156ZM12.6875 8V4.25H8.9375V8H12.6875ZM23.3125 15.5H22.6875C22.6875 17.5703 21.0078 19.25 18.9375 19.25C16.8672 19.25 15.1875 17.5703 15.1875 15.5H10.1875C10.1875 17.5703 8.50781 19.25 6.4375 19.25C4.36719 19.25 2.6875 17.5703 2.6875 15.5H2.0625C1.02734 15.5 0.1875 14.6602 0.1875 13.625V4.5625C0.1875 3.00781 1.44531 1.75 3 1.75H7.6875H13.9375H18.3555C19.0938 1.75 19.793 2.07422 20.2695 2.64062L24.6016 7.78516C24.9805 8.23438 25.1875 8.80469 25.1875 9.39453V13.625C25.1875 14.6602 24.3477 15.5 23.3125 15.5ZM20.8125 15.5C20.8125 15.0027 20.615 14.5258 20.2633 14.1742C19.9117 13.8225 19.4348 13.625 18.9375 13.625C18.4402 13.625 17.9633 13.8225 17.6117 14.1742C17.26 14.5258 17.0625 15.0027 17.0625 15.5C17.0625 15.9973 17.26 16.4742 17.6117 16.8258C17.9633 17.1775 18.4402 17.375 18.9375 17.375C19.4348 17.375 19.9117 17.1775 20.2633 16.8258C20.615 16.4742 20.8125 15.9973 20.8125 15.5ZM6.4375 17.375C6.93478 17.375 7.41169 17.1775 7.76333 16.8258C8.11496 16.4742 8.3125 15.9973 8.3125 15.5C8.3125 15.0027 8.11496 14.5258 7.76333 14.1742C7.41169 13.8225 6.93478 13.625 6.4375 13.625C5.94022 13.625 5.46331 13.8225 5.11167 14.1742C4.76004 14.5258 4.5625 15.0027 4.5625 15.5C4.5625 15.9973 4.76004 16.4742 5.11167 16.8258C5.46331 17.1775 5.94022 17.375 6.4375 17.375Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_636_3443">
					<path d="M0.1875 0.5H25.1875V20.5H0.1875V0.5Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
